import { CardOptionContent } from '@framework/form/inputs/card-group/CardOptionContent.tsx';
import { type IRadioCardOption } from '@framework/form/inputs/card-group/RadioCardGroupInput.tsx';
import { TbIcon } from '@framework/ui/components/icon/TbIcon.tsx';
import { yup } from '@framework/validation/initYup.ts';
import { IconForms, IconTextWrap } from '@tabler/icons-react';
import { type IWidgetComponentProps } from '../../../IWidgetType.ts';
import { WidgetType } from '../../../Widget.ts';
import {
  CommonConfigComponent,
  CommonInputWidgetConfigSchema,
} from '../common/CommonInputConfigComponent.tsx';
import { CommonKindInputConfig } from '../common/CommonKindInputConfig.tsx';
import { type ITextWidget, TextWidgetKind } from './ITextWidget.ts';

export const TextWidgetConfigSchema: yup.ObjectSchema<ITextWidget> =
  CommonInputWidgetConfigSchema.shape({
    type: yup.string().exact(WidgetType.Text).required(),
    kind: yup
      .string()
      .oneOfEnum(TextWidgetKind)
      .default(TextWidgetKind.Text)
      .required()
      .label('Tipo di campo'),
  })
    .required()
    .noUnknown();

const kindOptions: IRadioCardOption[] = [
  {
    value: TextWidgetKind.Text,
    label: (
      <CardOptionContent
        icon={<TbIcon icon={IconForms} />}
        title="Campo di Testo"
        description="Una sola riga, per testi brevi."
      />
    ),
  },
  {
    value: TextWidgetKind.TextArea,
    label: (
      <CardOptionContent
        icon={<TbIcon icon={IconTextWrap} />}
        title="Area di Testo"
        description="Riquadro multiriga, adatto a testi lunghi."
      />
    ),
  },
];

type ITextInputConfigComponentProps = IWidgetComponentProps<ITextWidget>;

export function TextInputConfigComponent(
  props: ITextInputConfigComponentProps,
) {
  return (
    <div>
      <CommonKindInputConfig kindOptions={kindOptions} />
      <CommonConfigComponent {...props} />
    </div>
  );
}
